import React from "react"
import styled from "@emotion/styled"

import ButtonLink from "../global/ButtonLink"

import CXL from "../../images/certs/cxl.png"
import Ideou from "../../images/certs/ideou.png"
import AJS from "../../images/certs/ajs.png"

const Outer = styled.section`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  padding: 96px 0;
  background: ${props => props.theme.shade[80]};
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Inner = styled.div`
  grid-column: 2;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`
const Cert = styled.div`
  display: grid;
  align-items: center;
  text-align: center;
  p {
    max-width: 240px;
    margin-left: auto;
    margin-right: auto;
  }
`
const Image = styled.img`
  width: 200px;
  height: 64px;
  object-fit: contain;
  margin-left: auto;
  margin-right: auto;
`
const PostCardContainer = styled.div`
  grid-column: 1/-1;
  display: grid;
  gap: 32px;
  max-width: 640px;
  margin: 64px auto 0 auto;
  text-align: center;
  p {
    margin: 0 auto;
    max-width: 480px;
  }
`

const ButtonContainer = styled.div`
  margin: 0 auto;
`

export default function Certs({
  postContent,
  buttonLink,
  buttonText,
  postCta,
}) {
  return (
    <Outer>
      <Inner>
        <Cert>
          <Image src={CXL} alt="CXL Certificate" />
          <p>Certified in Digital Psychology and Persuasion</p>
        </Cert>
        <Cert>
          <Image src={Ideou} alt="Ideou Certificate" />
          <p>Trained in Design Thinking by IDEO</p>
        </Cert>
        <Cert>
          <Image src={AJS} alt="AJS Certificate" />
          <p>Completed the Design Sprint Masterclass</p>
        </Cert>
        {postCta && (
          <PostCardContainer>
            {postContent && <p>{postContent}</p>}
            <ButtonContainer>
              <ButtonLink
                to={buttonLink}
                backgroundColorOverride={props => props.theme.primary}
              >
                {buttonText}
              </ButtonLink>
            </ButtonContainer>
          </PostCardContainer>
        )}
      </Inner>
    </Outer>
  )
}
